// Leidt de MVC-server-root af uit de API-URL door de afsluitende /api (met of zonder
// trailing slash) te strippen. De server-side MVC-flows voor externe login/koppeling
// (/mvc/Account/...) hangen op die root, niet onder /api. Eén definitie zodat de twee
// callers (login + account-koppeling) niet uit elkaar driften.
export function mvcRootFromApiUrl(apiUrl: string): string {
  return apiUrl.replace(/\/api\/?$/, "");
}
